
import { useParams, useLocation } from 'react-router-dom';
import { useReport } from '../../../../../api/hooks/useReport';
import { useSources } from '../../../../../api/hooks/useSources';
import BannerTrasparenzaESGDettaglio from '../../../../../components/report/listaDriverPage/trasperenza-esg/trasparenza-esg-dettaglio/BannerTrasparenzaESGDettaglio';
import ContainerTrasparenzaESGDettaglio from '../../../../../components/report/listaDriverPage/trasperenza-esg/trasparenza-esg-dettaglio/ContainerTrasparenzaESGDettaglio';
import useElementTrasparenzaEsgDettaglio from '../../../../../api/hooks/useElementTrasparenzaEsgDettaglio';
import { useEventsSearch } from '../../../../../api/hooks/useEventsSearch';
import { useMemo } from 'react';

const TrasparenzaESGDettaglioPage = () => {
  const { driverRoute, intermediarioName } = useParams<{
    name: string;
    driverRoute: string;
    intermediarioName: string;
  }>();

  const location = useLocation();
  const { idReport, driverId, key } = location.state || {};

const { report, loading: loadingReport, error: errorReport } = useReport(idReport);
const { elements, loading: loadingElements, error: errorElements } = useElementTrasparenzaEsgDettaglio(idReport, driverId, key);
const { sources, loading: loadingSources, error: errorSources } = useSources(idReport, driverId, key);

const payload = useMemo(() => ({
  report_id: idReport,
  element_id: key,
}), [idReport, key]);

const { events } = useEventsSearch(payload);

  if (loadingElements || loadingReport || loadingSources) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="w-20 h-20 border-[6px] border-gray-300 border-t-textPrimary rounded-full animate-spin" />
      </div>
    );
  }

  if (errorElements || errorReport || errorSources) {
    return <div>Si è verificato un errore durante il caricamento.</div>;
  }

  const intermediario = Array.isArray(elements) ? elements[0] : elements;

  if (!intermediario) {
    return <div>Nessun market maker trovato per questo ID.</div>;
  }

  return (
    <div className="flex flex-col bg-gray-50">
      <BannerTrasparenzaESGDettaglio
        report={report}
        title={driverRoute!}
        intermediarioName={intermediarioName}
        reportId={idReport}
        driverId={driverId}
      />
      <div className="px-8 lg:px-16 py-8">
        <ContainerTrasparenzaESGDettaglio
        intermediario={intermediario}
        title={driverRoute!}
        id={idReport}
        driverId={driverId}
        intermediarioId={key}
        sources={sources}
        events={events}
      />
      </div>
    </div>
  );
};


export default TrasparenzaESGDettaglioPage
